import { render, staticRenderFns } from "./AvatarCircle.vue?vue&type=template&id=50d2e6f6&scoped=true"
import script from "./AvatarCircle.vue?vue&type=script&lang=ts"
export * from "./AvatarCircle.vue?vue&type=script&lang=ts"
import style0 from "./AvatarCircle.vue?vue&type=style&index=0&id=50d2e6f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d2e6f6",
  null
  
)

export default component.exports